import React, { useState } from "react";
import Modal from "./Modal";
import ECForm from "./Registration/ECForm";
import FranchiseForm from "./Registration/FranchiseForm";
import StudentForm from "./Registration/StudentForm";
import "../assets/css/RegisterSection.css";

const RegisterSection = () => {
  const [modalType, setModalType] = useState(null);

  const openModal = (type) => setModalType(type);
  const closeModal = () => setModalType(null);

  return (
    <section className="register-section" id="register">
      <h2>Become a Part of <span>Aabhyas Mitra</span></h2>
      <p>Choose your category and register to join our growing education network.</p>

      <div className="register-grid">
        <div className="register-card" onClick={() => openModal("ec")}>
          <img src="https://cdn-icons-png.flaticon.com/512/3135/3135823.png" alt="EC" />
          <h3>Educational Counsellor</h3>
          <p>Register as an Abhyas Mitra (EC) and start guiding students.</p>
        </div>

        <div className="register-card" onClick={() => openModal("franchise")}>
          <img src="https://cdn-icons-png.flaticon.com/512/857/857681.png" alt="Franchise" />
          <h3>Franchise Partner</h3>
          <p>Join as a franchise and manage educational operations in your district.</p>
        </div>

        <div className="register-card" onClick={() => openModal("student")}>
          <img src="https://cdn-icons-png.flaticon.com/512/3135/3135731.png" alt="Student" />
          <h3>Student Enrollment</h3>
          <p>Get enrolled for 8th, 9th, or 10th grade programs.</p>
        </div>
      </div>

      {modalType && (
        <Modal onClose={closeModal}>
          {modalType === "ec" && <ECForm />}
          {modalType === "franchise" && <FranchiseForm />}
          {modalType === "student" && <StudentForm />}
        </Modal>
      )}
    </section>
  );
};

export default RegisterSection;
